import React from 'react';
import './App.css';
import Leaderboard from './Leaderboard';
import Socials from './Socials';

function App() {
  return (
    <div className="App">
      <main className="main-content">
        <div className="text-container">
          <div className='smooch-sans-description'>RE:AKTOR is a metroidvania action platformer where you can roll back time. Find and install drivers to unlock your lost abilities. Run and fight your way through a branching underground facility. Rewind time to beat the clock, and stop a great cataclysm.</div>
        </div>
        <div className="right-column">
          <Leaderboard />
        </div>
        <Socials />
      </main>
    </div>
  );
}

export default App;